export default {
	model: {
		prop: "checked",
		event: "change",
	},

	props: {
		label: String,
		checked: {
			type: String,
			default: "asc",
		},
		trueValue: { default: "desc" },
		falseValue: { default: "asc" },
	},

	computed: { isChecked },
};

function isChecked() {
	return this.checked === this.trueValue;
}
